/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type ClientSelfieUpdateMutationVariables = Types.Exact<{
  input: Types.ClientSelfieUpdateInput;
}>;
export type ClientSelfieUpdateMutation = {
  __typename?: "Mutation";
  clientSelfieUpdate?: {
    __typename?: "ClientSelfieUpdatePayload";
    result: {
      __typename?: "Client";
      id: string;
      selfieImageUrl?: string | null;
    } | {
      __typename?: "ClientSelfieUpdateError";
      code: Types.ClientSelfieUpdateErrorCode;
      message?: string | null;
    };
  } | null;
};
export const ClientSelfieUpdateDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "clientSelfieUpdate"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "input"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "ClientSelfieUpdateInput"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "clientSelfieUpdate"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "input"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "result"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "InlineFragment",
                typeCondition: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "Client"
                  }
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "id"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "selfieImageUrl"
                    }
                  }]
                }
              }, {
                kind: "InlineFragment",
                typeCondition: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "ClientSelfieUpdateError"
                  }
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "code"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "message"
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export type ClientSelfieUpdateMutationFn = Apollo.MutationFunction<ClientSelfieUpdateMutation, ClientSelfieUpdateMutationVariables>;

/**
 * __useClientSelfieUpdateMutation__
 *
 * To run a mutation, you first call `useClientSelfieUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClientSelfieUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clientSelfieUpdateMutation, { data, loading, error }] = useClientSelfieUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClientSelfieUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ClientSelfieUpdateMutation, ClientSelfieUpdateMutationVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useMutation<ClientSelfieUpdateMutation, ClientSelfieUpdateMutationVariables>(ClientSelfieUpdateDocument, options);
}
export type ClientSelfieUpdateMutationHookResult = ReturnType<typeof useClientSelfieUpdateMutation>;
export type ClientSelfieUpdateMutationResult = Apollo.MutationResult<ClientSelfieUpdateMutation>;
export type ClientSelfieUpdateMutationOptions = Apollo.BaseMutationOptions<ClientSelfieUpdateMutation, ClientSelfieUpdateMutationVariables>;